<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Support Us">
            <AmountSelector />
            <ErrorLabel field="amount" />
                    <FormRow inline>     
                      <LazyCurrencySelector :currencies="['USD', 'ILS', 'CAD']"/> 
                    </FormRow>               
            <TransactionFee />
            <br />
            <div style="line-height: normal; margin-bottom: 14px">
              Donations will be listed on the main campaign page with the name provided
              below. If you prefer your donation be listed anonymously, please click the
              box below.
            </div>
            <FormRow>
              <FormLabel for="anonymousCheck">
                <input
                  type="checkbox"
                  id="anonymousCheck"
                  :checked="getValue('custom.anonymous') === 'yes'"
                  @click="setValue('custom.anonymous', $event.target.checked ? 'yes' : 'no')"
                /> I would like my donation to be listed anonymously.
              </FormLabel>
            </FormRow>
            <br />
            <div style="line-height: normal; margin-bottom: 14px">
              If you would like to include a message or dedication that will appear on the
              campaign page, please click the box below and enter the text as you would
              like it to appear.
            </div>
            <ShortNote
              text="I would like to include a message or dedication that will appear on the campaign page"
            />
          </FormSection>
          <FormSection title="Donation Frequency:">
            <div class="frequency">
              <PaymentOptions addMonthly monthlyText="Monthly" />
            </div>
          </FormSection>           
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>             
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
                            <FormRow>
              <Receipt :receipts="['us', 'israel', 'canadian']" />
            </FormRow>     
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue, setValue, form } = usePaymentForm();

    return {
      getValue,
      setValue,
      form,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
</style>
